module.exports = __webpack_public_path__ + "media/images/logo_alt-6e6eab0bf51f61549bb0f469dffe6ae8.svg";